import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from '@mui/icons-material/Warning';

function ViolationsModal(props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    border: "2px solid #E2E8F0",
    borderRadius: "15px",
    boxShadow: 24,
    p: 4,
    maxHeight: "80vh",
    overflow: "auto",
    display: "flex",
    flexDirection: "column"
  };


  const violations = props.employeeLaborLawViolations

  return (
    <Modal
      open={props.open} // Set to true for demo
      onClose={() => props.handleClose()}
      aria-labelledby="labor-violations-modal"
    >
      <Box sx={style}>
        <div className="absolute right-2 top-2">
          <IconButton
            className="text-gray-400 hover:text-gray-600"
            onClick={() => props.handleClose()}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="mb-1">
            <div className="flex items-center space-x-3 mb-2">
              <WarningIcon className="text-rose-700 h-8 w-8" />
              <h3 className="text-xl font-semibold text-gray-900">
                Schedule Violations for {props.formattedName}
              </h3>
            </div>
            <p className="text-gray-600 text-sm">
              {violations?.length} violation{violations?.length !== 1 ? 's' : ''} detected for {props.formattedName}
            </p>
          </div>

          {/* Violations List */}
          <div className="flex-1 overflow-y-auto mb-6">
          {violations?.map((violation, index) => (
            <div key={index} className="border border-gray-200 rounded-lg p-4 my-5">
              <h3 className="font-semibold text-gray-900 mb-2">
                {violation.title}
              </h3>
              <p className="text-gray-700 text-sm mb-3">
                {violation.description}
              </p>
              <div className="bg-gray-50 p-3 rounded border-l-4 border-rose-500">
                <p className="text-sm text-gray-800">
                  {violation.explanation}
                </p>
              </div>
            </div>
          ))}
        </div>

          {/* Action buttons */}
          <div className="flex items-center space-x-3">
            <button
              className="flex-1 px-4 py-2.5 rounded-lg border border-gray-200 text-gray-700 hover:bg-gray-50 transition-colors duration-200 text-sm font-medium"
              onClick={() => props.handleClose()}
            >
              Close
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default ViolationsModal;
